import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Recent from "./Recent";
import { useParams, useNavigate } from "react-router-dom"; // ⬅️ Tambahkan useNavigate
import { getCategoryCampaign } from "../../Store/Action";
import clsx from "clsx";
import { useThemeClass } from "@/Hooks/useThemeClass";
import formatCategoriesData from "@/utils/formatCategoriesData";

function DetailCategory() {
  const themeClass = useThemeClass()
  const { label } = useParams(); // Ambil label dari URL
  const dispatch = useDispatch();
  const navigate = useNavigate(); // ⬅️ Untuk mengganti URL saat user pilih kategori

  const [selected, setSelected] = useState(0);
  const [selectedCtgId, setSelectedCtgId] = useState(0);
  const [selectedType, setSelectedType] = useState("");
  const [categoriesLoaded, setCategoriesLoaded] = useState(false);

  const dataCategory = useSelector(
    (state) => state.ReducerCategoryCampaign.categoryCampaignData || []
  );

  let formattedCategories = dataCategory?.data?.data || [];
  formattedCategories = formatCategoriesData(formattedCategories);

  // Ubah "모두" menjadi "전체" dan pastikan di urutan pertama
  let allIndex = formattedCategories.findIndex((cat) => cat.label === "모두");
  if (allIndex !== -1) {
    formattedCategories[allIndex] = {
      ...formattedCategories[allIndex],
      label: "전체",
      id: 0,
    };
    let [all] = formattedCategories.splice(allIndex, 1);
    formattedCategories.unshift(all);
  }

  // Pindahkan "등" ke urutan terakhir
  let etcIndex = formattedCategories.findIndex((cat) => cat.label === "등");
  if (etcIndex !== -1) {
    let [etc] = formattedCategories.splice(etcIndex, 1);
    formattedCategories.push(etc);
  }

  // Cek apakah kategori dari URL ada dan lakukan pemilihan kategori saat data kategori sudah siap
  useEffect(() => {
    if (formattedCategories.length > 0 && label) {
      let foundIndex = formattedCategories.findIndex(
        (cat) => cat.label === label
      );
      if (foundIndex !== -1) {
        setSelected(foundIndex);
        const foundCategory = formattedCategories[foundIndex];

        if(foundCategory.type === 'category'){
          setSelectedCtgId(foundCategory.id);
          setSelectedType("")
        } else {
          setSelectedCtgId(0)
          setSelectedType(foundCategory.id)
        }
      }
    }
    setCategoriesLoaded(true);
  }, [label, formattedCategories]);

  useEffect(() => {
    dispatch(getCategoryCampaign());
  }, [dispatch]);

  return (
    <div className="px-3">
      {/* Navbar */}
      {/* <div className="flex justify-between items-center py-3 border-b border-[#0F1E6C]">
        <Link to="/">
          <svg
            className="w-9 h-9 text-[#0F1E6C]"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              d="m14 8-4 4 4 4"
            />
          </svg>
        </Link>

        <p className="text-[#0F1E6C] font-bold text-lg">
          {formattedCategories[selected]?.label || "전체"}
        </p>

        <div className="w-6 h-6">
          <Link to="/">
            <img src={Home} alt="home" />
          </Link>
        </div>
      </div> */}

      {/* Category */}
      <div className="overflow-x-auto">
        <div className="flex w-max whitespace-nowrap border-b">
          {formattedCategories.map((category, index) => (
            <p
              key={category.id}
              className={`pb-2 pt-3 text-sm px-4 cursor-pointer ${
                selected === index
                  ? clsx(themeClass.text2('text2'), themeClass.border2('text2'), `font-bold border-b`)
                  : "text-gray-500"
              }`}
              onClick={() => {
                navigate(`/detailcategory/${encodeURIComponent(category.label)}`); // ⬅️ Ganti URL
              }}
            >
              {category.label}
            </p>
          ))}
        </div>
      </div>

      {/* Sorting */}
      <div className="pt-4">
        {categoriesLoaded && <Recent ctgId={selectedCtgId} campaignTypeId={selectedType} />}
      </div>
    </div>
  );
}

export default DetailCategory;
